export function getRelationTypeName(relationKey: string) {
  return relationTypes[relationKey] ?? relationKey;
}

export const relationTypes: Record<string, string> = {
  cover: $localize`:relation-type:Cover`,
  voiceOver: $localize`:relation-type:Voice Over`,
  contract: $localize`:relation-type:Contract`,
  product: $localize`:relation-type:Product`,
  collection: $localize`:relation-type:Collection`,
  assignment: $localize`:relation-type:Assignment`,
  music: $localize`:relation-type:Music`,
  stockMaterial: $localize`:relation-type:Stock Material`,
};
